import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import RoundedModal from '../../../../../../molecules/RoundedModal'
import NewVersionForm from './form'

const NewVersionDialog = React.forwardRef(function NewVersionDialog ({ blueprint, allVersions, onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false, initialData: null })

  const close = useCallback(() => {
    setDialogState({ open: false, processing: false, initialData: null })
  }, [setDialogState])

  const handleComplete = useCallback((e) => {
    close()
    onComplete(e)
  }, [close, onComplete])

  useImperativeHandle(ref, () => ({
    open: () => {
      setDialogState({ open: true, processing: false, initialData: null })
    },
    openWithData: (data) => {
      setDialogState({ open: true, processing: false, initialData: data })
    }
  }), [setDialogState])

  return (
    <RoundedModal
      title='New Version'
      open={dialogState.open}
      onClose={close}
      size='lg'
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (
          <NewVersionForm
            blueprint={blueprint}
            allVersions={allVersions || []}
            initialData={dialogState.initialData}
            onComplete={handleComplete}
            onCancel={close}
          />
        ) : null}
      </div>
    </RoundedModal>
  )
})

NewVersionDialog.propTypes = {
  blueprint: PropTypes.object.isRequired,
  allVersions: PropTypes.array,
  onComplete: PropTypes.func
}

NewVersionDialog.defaultProps = {
  allVersions: [],
  onComplete: () => {}
}

export default NewVersionDialog
